import React from 'react';
const chips = ['No forms to fill', 'Refunded to your original payment method', 'Keep the bonuses'];
export function Guarantee() {
  return <section aria-labelledby="guarantee-heading" className="w-full bg-navy" data-id="element-94" data-mp="1o5q1qgnuw7zz">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-95" data-mp="222whe2da9qkz">
        <div className="mx-auto flex h-24 w-24 flex-col items-center justify-center rounded-full border-[3px] border-gold text-gold" data-id="element-96" data-mp="1x421p9am4i53">
          <span className="font-display text-4xl leading-none" data-id="element-97" data-mp="19f0o77mxagsy">7</span>
          <span className="font-display text-xs uppercase tracking-widest" data-id="element-98" data-mp="14gpc0q95nu7k">
            Days
          </span>
        </div>
        <p className="mt-6 text-[11px] font-bold uppercase tracking-[1.6px] text-gold" data-id="element-99" data-mp="1j6554cw5sbqf">
          Zero risk
        </p>
        <h2 id="guarantee-heading" className="mt-3 font-display font-bold uppercase text-white text-3xl sm:text-5xl" data-id="element-100" data-mp="1ebr5tzedlkgh">
          Open it. Run a practice from it.
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base text-white/75" data-id="element-101" data-mp="lnc0k4l1qgic">
          Read the volumes, print a card, run one practice from it. If Sideline
          Ready doesn&apos;t change how you plan and run your week, email us
          inside 7 days and you get every cent back.
        </p>
        <ul className="mt-7 flex flex-wrap justify-center gap-2.5" data-id="element-102" data-mp="yrflasbcyp97">
          {chips.map(chip => <li key={chip} className="rounded-full border border-navy-line px-4 py-2 text-[13px] text-white/75" data-id="element-103" data-mp="12sr4og3n2e8y">
              {chip}
            </li>)}
        </ul>
      </div>
    </section>;
}